"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import TurnstileList from "./TurnstileList"
import TurnstileModal from "./TurnstileModal"
import type { Turnstile } from "./types"

const TurnstileContainer: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedTurnstile, setSelectedTurnstile] = useState<Turnstile | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = () => {
    setSelectedTurnstile(null)
    setModalOpen(true)
  }

  const handleOpenEdit = (turnstile: Turnstile) => {
    setSelectedTurnstile(turnstile)
    setModalOpen(true)
  }

  const handleSuccess = () => {
    setModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Turnstiles" parent="Access Control" />
      <Container fluid>
        <Row>
          <Col md="12">
            <TurnstileList onAdd={handleOpenAdd} onEdit={handleOpenEdit} refreshTrigger={refreshTrigger} />
          </Col>
        </Row>

        <TurnstileModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedTurnstile}
        />
      </Container>
    </>
  )
}

export default TurnstileContainer
